import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as THREE from 'three';
import EntwinePointTileNode from "../Core/EntwinePointTileNode";
import PointCloudLayer from "./PointCloudLayer";
import Extent from "../Core/Geographic/Extent";
var bboxMesh = new THREE.Mesh();
var box3 = new THREE.Box3();
bboxMesh.geometry.boundingBox = box3;
/**
 * @property {boolean} isEntwinePointTileLayer - Used to checkout whether this
 * layer is a EntwinePointTileLayer. Default is `true`. You should not change
 * this, as it is used internally for optimisation.
 */

var EntwinePointTileLayer = /*#__PURE__*/function (_PointCloudLayer) {
  _inherits(EntwinePointTileLayer, _PointCloudLayer);

  var _super = _createSuper(EntwinePointTileLayer);

  /**
   * Constructs a new instance of Entwine Point Tile layer.
   *
   * @constructor
   * @extends PointCloudLayer
   *
   * @example
   * // Create a new point cloud layer
   * const points = new EntwinePointTileLayer('EPT',
   *  {
   *      source: new EntwinePointTileSource({
   *          url: 'https://server.geo/ept-dataset',
   *      }
   *  });
   *
   * View.prototype.addLayer.call(view, points);
   *
   * @param {string} id - The id of the layer, that should be unique. It is
   * not mandatory, but an error will be emitted if this layer is added a
   * {@link View} that already has a layer going by that id.
   * @param {Object} config - Configuration, all elements in it
   * will be merged as is in the layer. For example, if the configuration
   * contains three elements `name, protocol, extent`, these elements will be
   * available using `layer.name` or something else depending on the property
   * name. See the list of properties to know which one can be specified.
   * @param {string} [config.crs=ESPG:4326] - The CRS of the {@link View} this
   * layer will be attached to. This is used to determine the extent of this
   * layer. Default to `EPSG:4326`.
   * @param {number} [config.skip=1] - Read one point from every `skip` points
   * - see {@link LASParser}.
   */
  function EntwinePointTileLayer(id, config) {
    var _this;

    _classCallCheck(this, EntwinePointTileLayer);

    _this = _super.call(this, id, config);
    _this.isEntwinePointTileLayer = true;

    var resolve = _this.addInitializationStep();

    _this.whenReady = _this.source.whenReady.then(function () {
      _this.root = new EntwinePointTileNode(0, 0, 0, 0, _assertThisInitialized(_this), -1);

      _this.root.bbox.min.fromArray(_this.source.boundsConforming, 0);

      _this.root.bbox.max.fromArray(_this.source.boundsConforming, 3);

      _this.extent = Extent.fromBox3(config.crs || 'EPSG:4326', _this.root.bbox);
      return _this.root.loadOctree().then(resolve);
    });
    return _this;
  }

  _createClass(EntwinePointTileLayer, [{
    key: "spacing",
    get: function get() {
      return this.source.spacing;
    }
  }]);

  return EntwinePointTileLayer;
}(PointCloudLayer);

export default EntwinePointTileLayer;